
import Vue from "vue";
import { showComponentMixin } from "@/utils/mixins";

export default Vue.extend({
    name: "SammanstallningField",
    mixins: [showComponentMixin],
    props: {
        fieldValue: {
            type: String,
            required: true,
        },
        textValue: {
            type: String,
            required: true,
        },
    },
});
